export default {
  toasts: {
    load_error: 'No se pudo cargar la configuración de pago',
    rails_saved: 'Canales de pago guardados',
    gateway_registered: 'Pasarela registrada',
    redact_failed: 'No se pudo redactar la pasarela',
    gateway_redacted: 'Pasarela redactada',
    sca_provisioned: 'Registro 3DS2 creado',
    company_assigned: 'Restaurante asignado',
    default_set: 'Pasarela predeterminada establecida; los nuevos restaurantes se asignarán a ella automáticamente',
    default_failed: 'No se pudo establecer la pasarela predeterminada',
    primary_switched: 'Pasarela principal cambiada a {{gateway}}',
    primary_switch_failed: 'No se pudo cambiar la pasarela principal',
  },
  custody: {
    title: 'Quién procesa los pagos',
    description:
      'Se decide una vez, al guardar el primer método, y queda bloqueado después: con su propia pasarela, el socio retiene los fondos; en la cuenta Adyen de FoodAmigos, FoodAmigos los retiene y paga la parte del socio mensualmente.',
    options: {
      provider: 'Pasarela propia del socio',
      platform: 'FoodAmigos procesa los pagos',
    },
    locked_notice: 'Bloqueado en «{{custodian}}» por la configuración de pagos: no se puede cambiar.',
    pick_first: 'Elige primero quién procesa los pagos.',
    lock_confirm: {
      title: '¿Bloquear los pagos a “{{custodian}}”?',
      description:
        'Guardar ahora decide quién custodia los fondos de este partner, y eso no se puede deshacer — ni aquí, ni por soporte. El sistema de pago aún se puede cambiar después; quién procesa los pagos, no.',
      confirm: 'Bloquear y guardar',
    },
  },
  rails: {
    title: 'Vía de pago',
    description:
      'El procesador con el que opera este partner — uno a la vez. Los restaurantes solo pueden cambiarse a la vía seleccionada aquí, y una vía no puede reemplazarse mientras algún restaurante siga cobrando por ella.',
    save: 'Guardar vía',
    multiple_warning:
      'Este partner todavía opera en más de una vía ({{rails}}). Al guardar solo se conserva la seleccionada arriba; el resto se eliminan, y el cambio se rechaza si algún restaurante sigue cobrando por una de ellas.',
    options: {
      stripe: 'Stripe',
      adyen: 'Adyen',
      spreedly: 'Pasarela local vía Spreedly',
    },
    platform_stripe_unavailable: 'Stripe en las cuentas de FoodAmigos aún no está disponible.',
    platform_custody_notice: 'No disponible cuando FoodAmigos procesa los pagos.',
    provider_custody_adyen_notice:
      'No disponible cuando el socio usa su propia pasarela: Adyen es la vía de procesamiento de FoodAmigos.',
  },
  spreedly_section_title: 'Configuración de Spreedly',
  gateways: {
    title: 'Pasarelas',
    description:
      'Las cuentas PSP propias del socio. El cobro completo se liquida en el adquirente de la pasarela seleccionada.',
    register: 'Registrar pasarela',
    empty: 'Aún no hay pasarelas registradas',
    columns: {
      gateway: 'Pasarela',
      status: 'Estado',
      sca: '3DS2',
      companies: 'Restaurantes',
    },
    statuses: {
      active: 'Activa',
      redacted: 'Redactada',
    },
    sca: {
      sandbox: 'Sandbox 3DS2',
      live: '3DS2 en producción',
      none: 'Sin 3DS2',
    },
    default_tag: 'Predeterminada',
    actions: {
      make_default: 'Marcar como predeterminada',
      check: 'Ejecutar verificación…',
      sca_provision: 'Configurar 3DS2…',
      sca_manage: 'Registro 3DS2…',
      redact: 'Redactar pasarela',
    },
  },
  redact_confirm: {
    title: '¿Redactar {{gateway}}?',
    description:
      'Las credenciales se eliminan en Spreedly y no se pueden restaurar. {{count}} restaurante(s) asignados siguen cobrando por esta pasarela; mientras haya alguno asignado, la redacción se rechaza y se te pide confirmar de nuevo.',
    redact: 'Redactar',
    force_title: '¿Redactar {{gateway}} de todos modos?',
    force_description:
      '{{count}} restaurante(s) siguen asignados a esta pasarela. Redactarla ahora rechazará su pago hasta que cada uno se asigne a otra pasarela. Esto no se puede deshacer.',
    force_redact: 'Redactar de todos modos',
  },
  companies: {
    title: 'Restaurantes',
    description: 'El procesador con el que cobra cada restaurante y su asignación de pasarela en Spreedly.',
    empty: 'No hay restaurantes',
    no_gateway: 'Ninguna',
    unassigned: 'Sin asignar',
    // The default gateway is assigned at creation and never fails the creation —
    // so a restaurant can end up unassigned with the reason only in the log.
    assignment_error_label: 'Error en la asignación automática',
    assign: 'Asignar',
    reassign: 'Reasignar',
    columns: {
      restaurant: 'Restaurante',
      primary_gateway: 'Pasarela principal',
      spreedly: 'Pasarela de Spreedly',
    },
    switch_primary_to: 'Cambiar a {{gateway}}',
    assign_modal: {
      title: 'Asignar {{company}} a una pasarela',
      assign: 'Asignar',
      gateway: 'Pasarela',
      make_primary: 'Hacer también de Spreedly la pasarela principal',
      make_primary_hint: 'Los cobros solo se enrutan por Spreedly mientras sea la pasarela principal.',
    },
  },
  register_modal: {
    title: 'Registrar una pasarela',
    register: 'Registrar',
    gateway_type: 'Tipo de pasarela',
    gateway_type_placeholder: 'Buscar en el catálogo de Spreedly…',
    auth_mode: 'Modo de autenticación',
    no_credentials: 'Este tipo de pasarela no necesita credenciales (sandbox de Spreedly).',
    description: 'Descripción',
    description_placeholder: 'p. ej., Acme Eats — Braintree EUR',
    acquirer_merchant_id: 'ID de comercio del adquirente',
    acquirer_hint: 'Opcional: se requiere junto con el MCC',
    mcc: 'MCC',
    mcc_hint: '4 dígitos, p. ej., 5812',
    make_default: 'Usar como predeterminada del partner',
    make_default_hint:
      'Los nuevos restaurantes del partner y los que aún no tienen pasarela se asignan a ella. Déjalo sin marcar si es el adquirente propio de un solo restaurante.',
  },
  sca_modal: {
    title: 'Registro 3DS2 — {{gateway}}',
    provision: 'Aprovisionar',
    irreversible_warning:
      'Irreversible: ni el perfil de comercio ni el proveedor SCA pueden editarse ni eliminarse después. Un BIN de adquirente incorrecto solo se manifiesta en el momento del cobro. Verifica cada valor con el banco adquirente antes de aprovisionar.',
    already_provisioned:
      'Ya aprovisionado (token del proveedor {{token}}). Aprovisionar de nuevo devuelve el registro existente a menos que esté activado Recrear.',
    type: {
      label: 'Tipo de proveedor',
      hint: '“Prueba” simula resultados de autenticación y se rechaza en producción.',
      test: 'Prueba (sandbox SCA)',
      live: 'Producción (Spreedly 3DS2 Global)',
    },
    country: {
      hint: 'El país bajo el cual el banco adquirente registró a este comerciante, no necesariamente donde está incorporado el partner. Aplica a todas las redes de tarjetas a continuación.',
      differs_warning:
        'Este no es el país del partner ({{country}}). Corrígelo si el adquirente registró al comerciante en otro lugar; de lo contrario verifícalo, porque un perfil de comerciante no se puede editar una vez creado.',
    },
    network_placeholder: 'Red de la tarjeta',
    add_network: 'Añadir red de tarjeta',
    networks: {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      discover: 'Discover',
      diners: 'Diners',
      jcb: 'JCB',
      dankort: 'Dankort',
      union_pay: 'UnionPay',
      cartes_bancaires: 'Cartes Bancaires',
    },
    fields: {
      acquirer_merchant_id: 'ID de comercio del adquirente',
      acquirer_bin: 'BIN del adquirente',
      mcc: 'MCC',
      merchant_name: 'Nombre del comercio',
      country_code: 'País (ISO-2)',
      merchant_url: 'URL del comercio',
    },
    recreate: {
      label: 'Recrear el registro',
      hint: 'Abandona para siempre el perfil de comercio y el proveedor SCA actuales y crea otros nuevos.',
    },
  },
  check_modal: {
    title: 'Comprobar pasarela — {{gateway}}',
    run: 'Ejecutar comprobación',
    done: 'Hecho',
    failed: 'No se pudo ejecutar la comprobación.',
    types: {
      verify: 'Verificar (sin mover dinero)',
      test_payment: 'Pago de prueba',
    },
    verify_unsupported: 'Este tipo de pasarela no admite verificación — ejecuta un pago de prueba en su lugar.',
    test_payment_warning:
      'Se realiza un cargo real en una pasarela activa y se reembolsa de inmediato. En pasarelas de mercados SCA, el emisor puede rechazar la prueba sin 3DS — eso igualmente demuestra que las credenciales llegaron al adquirente.',
    amount: 'Importe',
    amount_help: 'Entre 1,00 y 5,00',
    check_passed: 'Comprobación superada',
    check_failed: 'Comprobación fallida — ver los pasos a continuación',
    legs: {
      verify: 'Verificación',
      purchase: 'Cargo',
      credit: 'Reembolso',
    },
    leg_passed: 'Superado',
    leg_failed: 'Fallido',
  },
  card_fields: {
    script_failed: 'No se pudo cargar el script de Spreedly. Comprueba la red e inténtalo de nuevo.',
    full_name: 'Nombre del titular',
    number: 'Número de tarjeta',
    expiry: 'Caducidad',
    cvv: 'CVV',
  },
};
